module.exports = __webpack_public_path__ + "img/circle-card.0d13b848.png";